export default "__VITE_ASSET__BSxDlMhZ__"